export default __webpack_public_path__ + "static/media/03-new-era.f87aa3b7.png";